import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import PromptLibraryHeader from "./PromptLibraryHeader";
import NewPromptModal from "./NewPromptModal";
import SavedPromptItem from "./SavedPromptItem";
import { PlusIcon } from "../../../icons";
import { getCurrentPromptHost, loadPrompts, savePrompts, } from "../../../services/promptStorage";
const PromptLibraryApp = ({ initialHost }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingPrompt, setEditingPrompt] = useState(null);
    const [prompts, setPrompts] = useState([]);
    const [prefillContent, setPrefillContent] = useState(null);
    const [activeHost] = useState(() => initialHost || getCurrentPromptHost());
    // Check URL parameters and localStorage for "add" mode
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const mode = urlParams.get('mode');
        if (mode === 'add') {
            // Check localStorage for pending content
            const pendingData = localStorage.getItem('carousel_pending_prompt_add');
            if (pendingData) {
                try {
                    const parsed = JSON.parse(pendingData);
                    const hostMatches = !parsed.host || parsed.host === activeHost;
                    if (typeof parsed.content === "string" && parsed.content.trim() && hostMatches) {
                        setPrefillContent(parsed.content);
                        setIsModalOpen(true);
                        // Clear localStorage after reading
                        localStorage.removeItem('carousel_pending_prompt_add');
                    }
                }
                catch (error) {
                    console.error('Failed to parse pending prompt data:', error);
                    localStorage.removeItem('carousel_pending_prompt_add');
                }
            }
        }
    }, [activeHost]);
    // Load prompts from localStorage on mount
    useEffect(() => {
        const loaded = loadPrompts(activeHost);
        setPrompts(loaded);
        console.log(`[PromptLibraryApp] Loaded ${activeHost} prompts:`, loaded.length);
    }, [activeHost]);
    const handleCreateNew = () => {
        setEditingPrompt(null);
        setIsModalOpen(true);
    };
    const handleSavePrompt = (title, content) => {
        if (editingPrompt) {
            // Update existing prompt
            const updated = prompts.map((prompt) => prompt.id === editingPrompt.id ? { ...prompt, title, content } : prompt);
            setPrompts(updated);
            savePrompts(updated, activeHost);
        }
        else {
            // Create new prompt
            const newPrompt = {
                id: Date.now().toString(),
                title,
                content,
                host: activeHost,
            };
            // Always save directly to localStorage (simple approach)
            const updated = [...prompts, newPrompt];
            setPrompts(updated);
            savePrompts(updated, activeHost);
            console.log(`[PromptLibraryApp] ${activeHost} prompt saved:`, newPrompt.id);
        }
        setEditingPrompt(null);
        setPrefillContent(null);
        setIsModalOpen(false);
    };
    const handleEdit = (id) => {
        const prompt = prompts.find((p) => p.id === id);
        if (prompt) {
            setEditingPrompt(prompt);
            setIsModalOpen(true);
        }
    };
    const handleDelete = (id) => {
        const updated = prompts.filter((p) => p.id !== id);
        setPrompts(updated);
        savePrompts(updated, activeHost);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingPrompt(null);
        setPrefillContent(null);
    };
    return (_jsxs("div", { className: "flex flex-col h-screen w-full bg-white font-sans", children: [_jsx(PromptLibraryHeader, {}), _jsx("div", { className: "flex-1 overflow-y-auto pt-3 px-6 pb-6", children: _jsx("div", { className: "flex flex-col gap-10 w-full", children: _jsxs("div", { className: "flex flex-col gap-3 items-start w-full", children: [_jsxs("div", { className: "flex gap-3 items-center w-full", children: [_jsx("h2", { className: "flex-1 font-sans font-bold leading-normal text-[15px] text-gray-990 m-0", children: "Saved Prompts" }), _jsxs("button", { onClick: handleCreateNew, className: "bg-transparent border-none flex gap-1 items-center justify-center cursor-pointer hover:opacity-80 transition-opacity", type: "button", children: [_jsx("span", { className: "font-sans font-bold leading-normal text-[13px] text-primary-purple-70", children: "Create New Prompt" }), _jsx(PlusIcon, { size: 16, color: "#6050D7" })] })] }), _jsx("p", { className: "font-sans font-normal leading-normal text-[13px] text-gray-600 m-0 w-full", children: prompts.length > 0
                                    ? `${prompts.length} prompt${prompts.length !== 1 ? "s" : ""}`
                                    : "No saved prompts" }), prompts.length > 0 && (_jsx("div", { className: "flex flex-col gap-6 items-start w-full", children: prompts.map((prompt) => (_jsx(SavedPromptItem, { prompt: prompt, onEdit: handleEdit, onDelete: handleDelete }, prompt.id))) }))] }) }) }), _jsx(NewPromptModal, { isOpen: isModalOpen, onClose: handleCloseModal, onSave: handleSavePrompt, editingPrompt: editingPrompt, prefillContent: prefillContent })] }));
};
export default PromptLibraryApp;
